// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RZHM","label":"styles_label__Ehlya"};